/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Interestinnativelanguagecourses4Inputs */



/**

* @param {_Field_Interestinnativelanguagecourses4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_interestinnativelanguagecourses4 = /** @type {((inputs?: _Field_Interestinnativelanguagecourses4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Interestinnativelanguagecourses4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Interesse an herkunftssprachlichen Kursen")
});
export { _field_interestinnativelanguagecourses4 as "_field_interestInNativeLanguageCourses" }